import axios from "@/plugins/axios";

let url = "/api/console/shop/coupons";

export default {
    getCoupons(data){
        return axios.get(url, data).then(result => result.data);
    },
    getCoupon(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postCoupon(data){
        return axios.post(url, data).then(result => result.data);
    },
    putCoupon(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteCoupon(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
